export const ERROR_TEXT_GEO =
  'Вы запретили использовать данные о местоположении'
export const ERROR_TEXT_GEO_DEFAULT = 'Ошибка определения геолокации'

export const ERROR_TEXT_USER_BLOCKED = 'Ваша учетная запись заблокирована'
export const ERROR_TEXT_PERSONAL_DATA = 'Отозвано соглашение с ОПД'
